import styled from 'styled-components/macro';
import modularScale from '../../../styles/helpers/modular-scale';
import { primaryTypography } from 'styles/global/typography/typography';

const Label = styled('text')`
  ${primaryTypography};
  font-size: ${modularScale(-2)};
  font-weight: 400;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  fill: ${({ theme }) => theme.CasperGrey};
`;

export { Label };
